<template>
  <div class="w-100">
    {{opinionName(params.value)}}
  </div>
</template>

<script>

import techServiceModule from '@/store/tech-service/techServiceModule'
import { BBadge } from 'bootstrap-vue'
import store from '@/store'

export default {
  name: 'cell-renderer-taxi',
  components: {
    BBadge
  },
  data () {
    return {
      TECH_SERVICE_STORE_MODULE_NAME: 'techServiceModule',
    }
  },
  computed: {
    opinions () {
      return [
        {
          value: false,
          label: 'Ոչ'
        },
        {
          value: true,
          label: 'Այո'
        }
      ]
    },
    opinionName () {
      return (value) => {
        const index = this.opinions.findIndex((e) => e.value === value)
        if (index >= 0) {
          return this.opinions[index].label
        }
        return value
      }
    },
    color () {
      return (value) => {
        return (value) ? 'success' : 'danger'
      }
    }
  },
  created() {
    if (!store.hasModule(this.TECH_SERVICE_STORE_MODULE_NAME)) store.registerModule(this.TECH_SERVICE_STORE_MODULE_NAME, techServiceModule)
  },
}
</script>
